import { TIERS, PAYPAL } from '../config';
/** Small inline icons -- no icon library, no extra request. */
function Icon({ name }) {
    const common = {
        width: 22,
        height: 22,
        viewBox: '0 0 24 24',
        fill: 'none',
        stroke: 'currentColor',
        strokeWidth: 1.8,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        'aria-hidden': true,
    };
    if (name === 'upload') {
        return (<svg {...common}>
        <path d="M12 16V4"/>
        <path d="m7 9 5-5 5 5"/>
        <path d="M4 16v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"/>
      </svg>);
    }
    if (name === 'wand') {
        return (<svg {...common}>
        <path d="m5 19 9-9"/>
        <path d="m15 9 1.5-1.5"/>
        <path d="M18 3v4M16 5h4M5 7v2M4 8h2M18 15v2M17 16h2"/>
      </svg>);
    }
    return (<svg {...common}>
      <path d="M12 4v12"/>
      <path d="m7 11 5 5 5-5"/>
      <path d="M4 20h16"/>
    </svg>);
}
const STEPS = [
    {
        icon: 'upload',
        title: 'Add your image',
        body: 'Click the button, drag a file onto the page, or paste from your clipboard.',
    },
    {
        icon: 'wand',
        title: 'The background goes',
        body: 'It happens automatically on your own device, usually in a couple of seconds.',
    },
    {
        icon: 'download',
        title: 'Download the PNG',
        body: 'A transparent cutout you can drop straight into anything. No watermark.',
    },
];
const FAQS = [
    {
        q: 'Is it really free?',
        a: `Yes. Free downloads are unlimited, up to ${TIERS.free.maxEdge}px on the longest edge. There is no sign-up and no watermark.`,
    },
    {
        q: 'Do you see my photos?',
        a: 'No. Everything runs inside your browser on your own device. Your image is never uploaded, because there is no server to upload it to. You can switch off your internet after the page loads and it still works.',
    },
    {
        q: `What do I get for $${PAYPAL.price}?`,
        a: 'The full resolution of your original image instead of the free size cap, plus extra edge cleanup that removes the colour fringe left behind by the old background. One-time payment, no account, no subscription.',
    },
    {
        q: 'What kind of images work best?',
        a: 'Anything with a clear main subject: people, products, pets, furniture. Very fine detail like flyaway hair or glass is the hardest case for any tool, including this one.',
    },
];
export default function Landing() {
    return (<>
      <section className="steps">
        {STEPS.map((s, i) => (<div className="step" key={s.title}>
            <div className="step-top">
              <span className="step-num">{i + 1}</span>
              <span className="step-icon">
                <Icon name={s.icon}/>
              </span>
            </div>
            <h3>{s.title}</h3>
            <p>{s.body}</p>
          </div>))}
      </section>

      <section className="info">
        <h2>Questions</h2>
        {FAQS.map((f) => (<div className="faq" key={f.q}>
            <h3>{f.q}</h3>
            <p>{f.a}</p>
          </div>))}
      </section>
    </>);
}
